import { Area } from './area';
import { Media } from './media';
import { ObjectFitEnum, LinkDataPictureEnum, TemplateModeEnum } from '../../config/constants';
import { Sound } from './sound';

export class PictureArea extends Area {
  /**
   *
   */
  media: Media;
  /**
   *
   */
  objectFit: ObjectFitEnum;
  /**
   *
   */
  attribute: LinkDataPictureEnum;
  /**
   *
   */
  soundA: Sound;
  /**
   *
   */
  soundB: Sound;
  /**
   *
   */
  soundAPreview;
  /**
   *
   */
  soundBPreview;
  /**
   *
   */
  videoPreview;
  /**
   *
   */
  beforeTimetableDisplay: number;
  constructor(
    name?: string,
    width?: number,
    height?: number,
    posX?: number,
    posY?: number,
    index?: number,
    isFix?: boolean,
    isURL?: boolean,
    colorTextName?: string,
    attribute?: LinkDataPictureEnum,
    templateMode?: TemplateModeEnum
  ) {
    super(name, width, height, posX, posY, index, isFix, isURL, colorTextName, templateMode);
    this.objectFit = ObjectFitEnum.FILL;
    this.attribute = attribute;
    this.isTimingOn = false;
  }

  /**
   * override from area class
   * check type area
   * return false if area is picture area
   */
  checkTypeTextArea(): boolean {
    return false;
  }

  /**
   * override from area class
   * get picture area
   */
  getArea() {
    return this;
  }
}
